import { render, staticRenderFns } from "./RegisteredBySegment.vue?vue&type=template&id=3e9e8e39"
import script from "./RegisteredBySegment.vue?vue&type=script&lang=js"
export * from "./RegisteredBySegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports